// 챗 아이콘 컴포넌트

const ChatUserIcon = ({ iconImg, nickname, agent, color }) => {
  const bgColor = agent ? "#813DB5" : color;

  return (
    <div className="flex items-center gap-1.5 mb-2.5">
      <div
        className="p-1 flex justify-center items-center w-11 h-11 rounded-[18px]"
        style={{ backgroundColor: bgColor }}
      >
        <img src={iconImg} alt="Profile" />
      </div>
      <p className="text-sm font-semibold">{nickname}</p>
    </div>
  );
};

export default ChatUserIcon;
